export default __webpack_public_path__ + "static/media/air-conditioning.3959c519.svg";